import {
  Maybe,
  PaymentMethodsCustomerBankAccountSepaType,
  B2BPaymentMethod,
  PaymentMethodState,
} from "@oysterhr/schema"
import { Callout, Toast, useToast } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { PaymentMethodEnumType } from "~/app/utils/constants"
import { useReconfirmMandateLodging } from "../sepa/hooks/useReconfirmMandateLodging"

interface Props {
  customerBankAccount?: Maybe<B2BPaymentMethod>
  reconfirmMandateLodgingSuccessCallback: () => void
  onDelete: (paymentMethod: PaymentMethodsCustomerBankAccountSepaType) => void
}

export const SepaFteVerificationFailureAlert = ({
  customerBankAccount,
  onDelete,
  reconfirmMandateLodgingSuccessCallback,
}: Props) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts.sepaFteVerificationFailure",
  })
  const toast = useToast()
  const [reconfirmMandateLodging, { loading: reconfirmingMandateLodging }] =
    useReconfirmMandateLodging({
      onCompleted: data => {
        if (data.reconfirmMandateLodging.errors.length) {
          toast({
            render: (
              <Toast variation="error">
                <Toast.Content>{data.reconfirmMandateLodging.errors.join(", ")}</Toast.Content>
              </Toast>
            ),
          })
        } else {
          reconfirmMandateLodgingSuccessCallback()
        }
      },
    })

  if (
    customerBankAccount?.__typename !== PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    customerBankAccount?.state !== PaymentMethodState.VerificationFailed
  )
    return null

  return (
    <Callout variation="error">
      <Callout.Heading>{t("title")}</Callout.Heading>
      <Callout.Content>{t("content")}</Callout.Content>
      <Callout.Actions>
        <Callout.ActionButton
          isLoading={reconfirmingMandateLodging}
          onClick={() => {
            if (customerBankAccount.mandate)
              reconfirmMandateLodging({
                variables: {
                  mandateId: customerBankAccount.mandate.id,
                },
              })
          }}
        >
          {t("action")}
        </Callout.ActionButton>
        <Callout.ActionLink
          onClick={() => {
            onDelete(customerBankAccount)
          }}
          to={"#"}
        >
          {t("link")}
        </Callout.ActionLink>
      </Callout.Actions>
    </Callout>
  )
}
